import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Navigation slice state interface
export interface NavigationState {
  isNavigationEnabled: boolean;
}

// Initial state
const initialState: NavigationState = {
  isNavigationEnabled: true, // Navigation enabled by default
};

// Create the navigation slice
const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    // Set navigation enabled/disabled state
    setNavigationEnabled: (state, action: PayloadAction<boolean>) => {
      state.isNavigationEnabled = action.payload;
    },

    // Toggle navigation state
    toggleNavigation: (state) => {
      state.isNavigationEnabled = !state.isNavigationEnabled;
    },

    // Enable navigation
    enableNavigation: (state) => {
      state.isNavigationEnabled = true;
    },

    // Disable navigation
    disableNavigation: (state) => {
      state.isNavigationEnabled = false;
    },
  },
});

// Export actions
export const {
  setNavigationEnabled,
  toggleNavigation,
  enableNavigation,
  disableNavigation,
} = navigationSlice.actions;

// Export selectors
export const selectIsNavigationEnabled = (state: { navigation: NavigationState }) =>
  state.navigation.isNavigationEnabled;

// Export reducer
export default navigationSlice.reducer;
